/* Native Shopify contact forms (export_theme.py converts the prototype forms listed in tools/shopify/forms.json).
   Progressive enhancement over {% form 'contact' %}:
   - the page's own validation still runs; when every field is valid this script lets the browser post the form (the prototype handler would
     have called preventDefault and shown a fake success state);
   - contact[body] is built from the fields, so the notification email is readable (the old trial modal did the same);
   - dataLayer events: on submit trial_form_submitted (the trial form) or contact_form_submitted (the contact and custom build forms); when Shopify returns with the success state
     trial_request_received (trial, secondary conversion) or contact_request_received (contact and custom build, primary conversion). One success event per accepted submit.
   - generate_lead (Google Analytics recommended event): sent together with the success event, with lead_type trial or contact, so every accepted form shows under one event name.
   Without JavaScript the form still posts and every contact[...] field arrives in the notification email. */
(function () {
  'use strict';
  var KEY = 'ow-lead-sent';
  /* The trial form is #start-form; the contact page and the custom build page both post a contact form. */
  function kind(form) { return form && form.id === 'start-form' ? 'trial' : 'contact'; }
  function track(name, form) {
    var detail = { form_id: form ? form.id : '', page_path: location.pathname };
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: name, form_id: detail.form_id, page_path: detail.page_path }); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, detail); } catch (e) {}
  }
  function trackLead(form) {
    var detail = { lead_type: kind(form), form_id: form ? form.id : '', page_path: location.pathname };
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'generate_lead', lead_type: detail.lead_type, form_id: detail.form_id, page_path: detail.page_path }); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', detail); } catch (e) {}
  }
  function labelOf(field) {
    var l = field.id && document.querySelector('label[for="' + field.id + '"]');
    var t = l ? l.textContent : (field.getAttribute('name') || '').replace(/^contact\[|\]$/g, '');
    return t.replace(/\*/g, '').replace(/\(optional\)/i, '').replace(/\s+/g, ' ').trim();
  }
  function summary(form) {
    var lines = [];
    [].slice.call(form.elements).forEach(function (el) {
      var n = el.getAttribute && el.getAttribute('name');
      if (!n || n.indexOf('contact[') !== 0 || el.type === 'hidden' || el.type === 'submit' || el.type === 'button') return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (n === 'contact[body]' && el.tagName === 'TEXTAREA') return;
      var v = el.tagName === 'SELECT' ? (el.options[el.selectedIndex] ? el.options[el.selectedIndex].text : '') : el.value;
      if (String(v).trim()) lines.push(labelOf(el) + ': ' + String(v).trim());
    });
    return lines.join('\n');
  }
  var sent = document.querySelector('form[data-ow-contact] [data-ow-sent], form[data-ow-contact] [data-ow-tracking-success]');
  if (sent) {
    try {
      sent.focus();
      if (!sessionStorage.getItem(KEY)) { sessionStorage.setItem(KEY, '1'); var f = sent.closest('form'); track(kind(f) + '_request_received', f); trackLead(f); }
    } catch (e) {}
  } else {
    try { sessionStorage.removeItem(KEY); } catch (e) {}
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-ow-contact')) return;
    var enhanced = !!form.querySelector('[data-ow-email-optin]');
    if (!enhanced && form.getAttribute('data-ow-busy') === '1') { e.preventDefault(); e.stopImmediatePropagation(); return; }
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;   /* the page's own handler shows its messages */
    var body = form.querySelector('[data-ow-body]');
    if (body) {
      var s = summary(form), source = form.querySelector('input[name="contact[Source]"]');
      body.value = (body.getAttribute('data-ow-lead') || 'Lead') + (source ? ' from ' + source.value : '') + (s ? '\n' + s : '');
    }
    if (enhanced && window.OmniEmailConsent && !window.OmniEmailConsent.prepare(form)) {
      e.preventDefault(); e.stopImmediatePropagation(); return;
    }
    track(kind(form) + '_form_submitted', form);
    /* Backup capture: a copy of the contact[...] fields goes to the booking backup endpoint (data-ow-backup), so a lead is kept even if Shopify's email is lost. */
    try {
      var bk = form.getAttribute('data-ow-backup');
      if (bk && navigator.sendBeacon) {
        var q = new URLSearchParams();
        Array.prototype.forEach.call(form.elements, function (el) { if (el.name && el.name.indexOf('contact[') === 0 && el.type !== 'checkbox') q.append(el.name, el.value); });
        q.append('page', location.pathname);
        navigator.sendBeacon(bk, q);
      }
    } catch (err) {}
    /* Consent forms use native-aware page handlers, so Shopify must receive their events.
       Keep the legacy prototype guard for other contact forms. */
    if (!enhanced) {
      form.setAttribute('data-ow-busy', '1');
      var btn = form.querySelector('button[type="submit"]');
      if (btn) setTimeout(function () { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }, 0);
      e.stopImmediatePropagation();
    }
  }, true);
})();
